<template>
  <div class="reset-wrapper">
    <div class="reset-box">
      <div class="card-header bg-success text-center">
        <span class="h4 text-white">パスワード再設定</span>
      </div>
      <div class="card-body">
        <p class="text-muted mb-3">新しいパスワードを入力してください</p>

        <form @submit.prevent="submitReset">
          <div class="input-group mb-3">
            <input :type="showPassword ? 'text' : 'password'" class="form-control" placeholder="新しいパスワード" v-model="password" required>
            <div class="input-group-append">
              <div class="input-group-text" style="cursor:pointer;" @click="showPassword = !showPassword">
                <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </div>
            </div>
          </div>
          <div class="input-group mb-3">
            <input :type="showPassword ? 'text' : 'password'" class="form-control" placeholder="パスワード確認" v-model="confirmPassword" required>
            <div class="input-group-append">
              <div class="input-group-text" style="cursor:pointer;" @click="showPassword = !showPassword">
                <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </div>
            </div>
          </div>
          <p v-if="errorMessage" class="text-danger text-center mb-3">{{ errorMessage }}</p>
          <p v-if="successMessage" class="text-success text-center mb-3">{{ successMessage }}</p>
          <button type="submit" class="btn btn-success btn-block" :disabled="isLoading">
            <span v-if="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
            <span>パスワードを変更する</span>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      password: '',
      confirmPassword: '',
      showPassword: false,
      isLoading: false,
      errorMessage: '',
      successMessage: '',
    }
  },
  mounted() {
    const token = this.$route.query.token;
    if (!token) {
      this.errorMessage = '無効なリンクです。もう一度パスワードリセットをお試しください。';
    }
  },
  methods: {
    async submitReset() {
      this.errorMessage = '';
      this.successMessage = '';

      if (this.password.length < 6) {
        this.errorMessage = 'パスワードは6文字以上で入力してください';
        return;
      }
      if (this.password !== this.confirmPassword) {
        this.errorMessage = 'パスワードが一致しません';
        return;
      }

      const token = this.$route.query.token;
      if (!token) {
        this.errorMessage = '無効なトークンです';
        return;
      }

      this.isLoading = true;
      try {
        const response = await this.$http.post(process.env.VUE_APP_API_PATH + '/auth/update-password', {
          token: token,
          password: this.password,
        });
        if (response.data.success) {
          this.successMessage = 'パスワードを変更しました。ログイン画面に移動します...';
          setTimeout(() => {
            this.$router.push('/');
          }, 2000);
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.errorMessage = error.response.data.message || 'パスワードの変更に失敗しました。リンクが無効または期限切れの可能性があります。';
        } else {
          this.errorMessage = 'パスワードの変更に失敗しました';
        }
      }
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.reset-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8f5e9 100%);
}
.reset-box {
  width: 400px;
  max-width: 90vw;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  overflow: hidden;
}
.card-body {
  padding: 24px;
}
</style>
